import { Info } from "lucide-react";
import Reveal from "./Reveal";
import SectionHeading from "./SectionHeading";

const STEPS = [
    {
        n: "01",
        title: "Listen",
        text: "We begin with a conversation — your concerns, your routine, and your health background. Please share any medical conditions or ongoing treatment with us.",
    },
    {
        n: "02",
        title: "Personalise",
        text: "Your session is planned around you: the regions to work on, the pressure you are comfortable with, and the pace that suits you.",
    },
    {
        n: "03",
        title: "Session",
        text: "Gentle, precise touch on selected marma points, often with warm herbal oils in the Abhyanga tradition. You simply rest.",
    },
    {
        n: "04",
        title: "Rest & Guidance",
        text: "A few quiet minutes after the session, with simple aftercare suggestions for the rest of your day.",
    },
];

export default function Procedure() {
    return (
        <section id="procedure" data-testid="procedure-section" className="bg-forest py-20 md:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <SectionHeading
                    overline="The Procedure"
                    title="What a Session With Us Looks Like"
                    dark
                    testId="procedure-heading"
                >
                    No two sessions are identical, but each follows the same calm, careful rhythm.
                </SectionHeading>

                <div className="relative mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
                    <div className="absolute left-10 right-10 top-14 hidden border-t border-dashed border-gold/30 lg:block" aria-hidden="true" />
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.08}>
                            <div
                                data-testid={`procedure-step-${i}`}
                                className="relative z-10 flex h-full flex-col rounded-3xl border border-cream/15 bg-cream/5 p-8 backdrop-blur-sm transition-colors duration-500 hover:bg-cream/10"
                            >
                                <span className="font-serif text-5xl font-medium text-gold/80">{s.n}</span>
                                <h3 className="mt-6 font-serif text-2xl font-medium text-cream">{s.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-cream/75">{s.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2}>
                    <div className="mt-12 flex gap-4 rounded-2xl border border-gold/30 bg-ink/20 p-6" data-testid="procedure-safety-note">
                        <Info className="mt-0.5 h-6 w-6 shrink-0 text-gold" />
                        <p className="text-sm leading-relaxed text-cream/85">
                            <span className="font-semibold text-cream">Safety first.</span> Marma
                            Chikitsa is gentle and non-invasive, and it remains a complementary wellness
                            practice. If you are pregnant, recovering from surgery or injury, or managing
                            a health condition, please consult your physician first — and tell us before
                            your session so we can adapt or advise accordingly.
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
